﻿export default class CreditChangeViewModel {
    public organisation: number = 0;
    public formType: number = 0;
    public amount: number = 0;
    public reason: string = '';
}